import { render, staticRenderFns } from "./TopicModelList.vue?vue&type=template&id=8249a4a0&"
import script from "./TopicModelList.vue?vue&type=script&lang=js&"
export * from "./TopicModelList.vue?vue&type=script&lang=js&"
import style0 from "./TopicModelList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports